export default __webpack_public_path__ + "static/media/T_64_desktop.e33c1bdc.jpg";